<template>
  <div class="h-100">
    <div>
      <transition mode="out-in">
        <router-view />
      </transition>
    </div>
    <div class="fixed footer">
      <the-footer />
    </div>
  </div>
</template>

<script>
import TheFooter from "../components/TheFooter.vue";
export default {
  components: { TheFooter },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>

<style scoped>
.footer {
  bottom: 0px;
  width: 100%;
  background-color: #6cc58c;
}
</style>